module["exports"] = [
  "01##"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ge/address/postcode.js
 ** module id = 724
 ** module chunks = 0
 **/